import { Typography } from '@mui/material';
import {
  MAX_VESSEL_BATCH_SIZE,
  MyFleetCsvHeaderDisplayNames,
  MyFleetCsvHeaders,
} from '../../../../models/my-fleet.model';

interface CsvUploadStatusProps {
  file: File | null;
  failedEmails: string[];
  failedImos: string[];
  vessels: { imo: number; emails: string[] }[];
  uploadError: string | null;
  numAlerts: number | undefined;
}

export default function CsvUploadStatus({
  file,
  failedEmails,
  failedImos,
  vessels,
  uploadError,
  numAlerts,
}: CsvUploadStatusProps) {
  if (!file) {
    return (
      <Typography textAlign="left">
        {`Note: The CSV should have the following columns: "${
          MyFleetCsvHeaderDisplayNames[MyFleetCsvHeaders.IMO]
        }", "${
          MyFleetCsvHeaderDisplayNames[MyFleetCsvHeaders.VesselContactEmails]
        }", and "${
          MyFleetCsvHeaderDisplayNames[MyFleetCsvHeaders.ShoreContactEmails]
        }". Email addresses should be comma-separated and enclosed in quotes if multiple are required, there is a limit of 20 email addresses per alert.`}
      </Typography>
    );
  }
  if (failedEmails.length > 0) {
    return (
      <Typography color="error" textAlign="left">
        {`The file contains invalid email addresses like "${failedEmails[0]}". Please ensure all emails are in the format "user@example.com" and separated by commas if multiple.`}
      </Typography>
    );
  }
  if (failedImos.length > 0) {
    return (
      <Typography color="error" textAlign="left">
        {`The file contains invalid IMOs like "${failedImos[0]}". Please ensure all IMOs are 7-digit numbers.`}
      </Typography>
    );
  }
  if (
    file &&
    vessels.length === 0 &&
    failedEmails.length === 0 &&
    failedImos.length === 0 &&
    !uploadError
  ) {
    return (
      <Typography color="error" textAlign="left">
        No valid vessels found. Please check the uploaded file for errors.
      </Typography>
    );
  }
  if (
    file &&
    vessels.length > MAX_VESSEL_BATCH_SIZE &&
    failedEmails.length === 0 &&
    failedImos.length === 0 &&
    !uploadError
  ) {
    return (
      <Typography color="error" textAlign="left">
        {`Selected CSV exceeds maximum of ${MAX_VESSEL_BATCH_SIZE} vessels in one batch.`}
      </Typography>
    );
  }
  if (
    file &&
    vessels.length > 0 &&
    failedEmails.length === 0 &&
    failedImos.length === 0 &&
    !uploadError
  ) {
    return (
      <Typography textAlign="left">
        {`Ready to add ${vessels.length} vessel(s) from the uploaded file. `}
        {numAlerts && numAlerts > 0
          ? `${numAlerts} of these will have PRO alert(s) created.`
          : ''}
      </Typography>
    );
  }
  if (uploadError) {
    return (
      <Typography color="error" textAlign="left">
        {uploadError}
      </Typography>
    );
  }
  return null;
}
